import { type FC } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Grid, Typography } from "@mui/material";
import { useToken } from "@packsize/authentication";

import { type ApiKeyResponse } from "../../../types";

import { ApiKeyValueRow } from "./api-key-value-row";

interface ApiKeySuccessStepProps {
	readonly credentials: ApiKeyResponse;
	readonly onCopyToClipboard: (value: string) => void;
}

export const ApiKeySuccessStep: FC<ApiKeySuccessStepProps> = ({ credentials, onCopyToClipboard }) => {
	const intl = useIntl();
	const { decodedToken } = useToken();
	const tenantId = decodedToken?.tid ?? "";
	const apiKey = credentials.responseData?.properties?.primaryKey ?? "";
	const authorizationHeader = tenantId && apiKey ? `Basic ${btoa(`${tenantId}:${apiKey}`)}` : "";

	return (
		<Grid container direction="column" wrap="nowrap" spacing={2}>
			<Grid container direction="column" gap={1}>
				<Typography>
					<FormattedMessage id="Here is your new API key." defaultMessage="Here is your new API key." />
				</Typography>
				<Typography fontWeight={700}>
					<FormattedMessage
						id="This is the only time this will be displayed, so be sure to copy it."
						defaultMessage="This is the only time this will be displayed, so be sure to copy it."
					/>
				</Typography>
			</Grid>

			<ApiKeyValueRow
				label={intl.formatMessage({ id: "Tenant ID", defaultMessage: "Tenant ID" })}
				value={tenantId}
				onCopyToClipboard={onCopyToClipboard}
				copyButtonPendoId="connection-success__button__copy-tenant-id"
			/>

			<ApiKeyValueRow
				label={intl.formatMessage({ id: "API Key", defaultMessage: "API Key" })}
				value={apiKey}
				onCopyToClipboard={onCopyToClipboard}
				copyButtonPendoId="connection-success__button__copy-api-key"
			/>

			<ApiKeyValueRow
				label={intl.formatMessage({ id: "Authorization Header", defaultMessage: "Authorization Header" })}
				value={authorizationHeader}
				onCopyToClipboard={onCopyToClipboard}
				copyButtonPendoId="connection-success__button__copy-authorization-header"
			/>
		</Grid>
	);
};
